/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerformatwhite3Inputs */

const en_checkinflyerformatwhite3 = /** @type {(inputs: Checkinflyerformatwhite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print (white)`)
};

const de_checkinflyerformatwhite3 = /** @type {(inputs: Checkinflyerformatwhite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Ausdrucken (weiß)`)
};

/**
* | output |
* | --- |
* | "Print (white)" |
*
* @param {Checkinflyerformatwhite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerformatwhite3 = /** @type {((inputs?: Checkinflyerformatwhite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerformatwhite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerformatwhite3(inputs)
	return de_checkinflyerformatwhite3(inputs)
});
export { checkinflyerformatwhite3 as "checkinFlyerFormatWhite" }